<h1 mat-dialog-title>{{title}}</h1>

<div mat-dialog-content>
  {{message}}
</div>

<mat-dialog-actions  align="end">
  <button type="button" mat-button (click)="onDismiss()">No</button>
  <button type="button" mat-raised-button color="accent" (click)="onConfirm()">Yes</button>
</mat-dialog-actions>
